<script setup>

import {computed, ref} from "vue";
import {useChatStore} from "../../store/chat.js";
import {useModalStore} from "../../store/modal.js";

const store = useChatStore()
const message = ref('')
const focusState = ref(false)
const modalStore = useModalStore()
const loading = ref(false)

const props = defineProps({
    chatId: Number,
})

const hasFocus = computed(() => {
    return focusState.value || message.value.length
})

const send = async () => {
    loading.value = true
    await store.addMessage(message.value)
    message.value = ''
    loading.value = false
    modalStore.close();
}

</script>

<template>
    <div class="message-send-box" :class="{'--is-focused': hasFocus}">
        <button class="attachment-button"
                @click='modalStore.open("MessageAttachment", {type: "chat"}, ".message-send-box", "center-left")'>
            <ah-icon name="attach"/>
        </button>
        <textarea placeholder="Type a message" v-model="message" @focus="focusState = true"
                  @focusout="focusState = false"></textarea>
    </div>
    <brand-button variant="primary" @click.prevent="send" :disabled="loading"><span class="label">Send</span>
        <ah-icon name="send"/>
    </brand-button>
</template>

<style lang="scss">
.message-send-box {
    background: #fff;
    border-radius: 2.4rem;
    width: 100%;
    height: 100%;
    padding: .5rem;
    transition: height .2s ease;
    display: flex;
    gap: 1rem;
    position: relative;

    .attachment-button {
        min-width: 3.6rem;
        min-height: 3.6rem;
        width: 3.6rem;
        height: 3.6rem;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        margin: .8rem 0 .8rem .5rem;
        background: var(--color-white);
        border: none;
        transition: .3s ease-in-out;
        position: relative;

        .icon {
            fill: var(--color-hazy);
        }

        &:hover {
            background: var(--color-raspberry) !important;

            .icon {
                fill: var(--color-white);
            }
        }
    }

    textarea {
        display: block;
        background: var(--color-grey-mist);
        border-radius: 2rem;
        border: none;
        resize: none;
        width: 100%;
        height: 5rem;
        line-height: 3rem;
        padding: 1rem;
        @include font(1.4, 3, book);
        color: var(--color-grey-thunder);
        transition: all .2s ease;
    }

    &.--is-focused {
        //height: 18rem;

        textarea {
            height: 17rem;
            line-height: initial;
        }
    }

    @include dark() {
        background: var(--color-darth-maul);

        textarea {
            background: var(--color-darth-sidious);
            color: var(--color-mist);
        }

        .attachment-button {
            background: var(--color-darth-maul);

            .icon {
                fill: var(--color-dew);
            }
        }
    }
}
</style>
